module.exports = __webpack_public_path__ + "files/e4986ccb27962bb1fefbcea1a17e9446.png";